/**
 * A entrada "Corrigir" no card do pacote, na conferência das saídas e na conferência final (E171.F3;
 * E202.F3, GUS-145, ADR-0145 §9): abre a mesa já na saída, onde o documento se edita no próprio
 * bloco. Com `trecho`, a mesa abre o trecho apontado.
 */
import { Link } from 'react-router-dom';

import { ptBR } from '@/i18n/pt-BR';
import type { SaidaDaEdicao } from '@/lib/correcaoDoRascunho';

export function enderecoDaMesa(caseId: string, saida: SaidaDaEdicao, trecho?: string): string {
  const base = `/casos/${caseId}/mesa?saida=${saida}`;
  return trecho === undefined ? base : `${base}&trecho=${encodeURIComponent(trecho)}`;
}

export interface CorrigirNaMesaProps {
  caseId: string;
  saida: SaidaDaEdicao;
  /** A saída que não se corrige ali (final, ou fora desta versão): a entrada não aparece. */
  oculto?: boolean;
}

export function CorrigirNaMesa({ caseId, saida, oculto = false }: CorrigirNaMesaProps) {
  if (oculto) return null;
  return (
    <Link
      className="text-body-sm text-accent-700 underline"
      to={enderecoDaMesa(caseId, saida)}
      data-testid={`corrigir-${saida}`}
    >
      {ptBR.editorManual.corrigir}
    </Link>
  );
}
